import React, { useContext, useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import './QuizDetailsModal.css'
import '../../../assets/css/modal.css'
import { dataContext } from '../../../App';
import activityLogSubmission from '../../../helper/activitylog';
import analyticEvent from '../../../helper/gaEvent';
import { LuClock3 } from "react-icons/lu";
import xImg from './x.png';
import { GrCircleQuestion } from "react-icons/gr";
import { FaCalendarDay } from "react-icons/fa";
import { FaMoneyBill } from "react-icons/fa";
import styles from './QuizDetailsModal.module.css';
import { convertToBengaliNumber } from './helper';
// import QuizRewards from './QuizRewards';
// import QuizWinnerList from './QuizWinnerList';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { fetchSubscriptionUrl, fetchSubscriptionUrlByEventId } from '../../../services';
import { Spinner } from 'react-bootstrap';
const QuizDetailsModal = ({ showQuizDetailsModal, setShowQuizDetailsModal, activeQuizBannerId,setShowOtpModal,setShowGameSelectionModal,setShowDifficultyModal }) => {
  const navigate = useNavigate();
  const { events,playerData,token } = useContext(dataContext);
  const [isLoading, setIsLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();


  function hideModalOperation() {
    setShowQuizDetailsModal(false)
    searchParams.delete('active')
    setSearchParams(searchParams)
  }

  useEffect(() => {
    activityLogSubmission("QuizDetailsModal");
    analyticEvent('QuizDetailsModal', 'QuizDetailsModal-view')
  }, [])
  let serviceType = 
  (activeQuizBannerId === 'wordly') ? 'Wordly' :
  (activeQuizBannerId === 'spelling_bee') ? 'SpellingBee' :
  (activeQuizBannerId === 'memory_match') ? 'MemoryMatch' :
  null;
  useEffect(()=>{
    let activeBannerNameInUrl =
    (activeQuizBannerId === 'wordly') ? 'wordly_weekly' :
    (activeQuizBannerId === 'spelling_bee') ? 'spelling_bee_weekly' :
    (activeQuizBannerId === 'memory_match') ? 'memory_match_weekly' :
    null;
  
  searchParams.set('active', activeBannerNameInUrl);
  setSearchParams(searchParams)
  },[])

  let event = {};
  let showKhelunButton = false;
  let showTrialButton = false;
  let showSubscribeButton = false;
  const memoryMatchHardPlay = () => {
    sessionStorage.setItem("memoryMatchDifficulty", 'advanced');
    navigate(`/quiz/?eventId=${151}`)
  };

  if(activeQuizBannerId === 'wordly') {
    if(playerData?.isSubscribe) {
      showKhelunButton = true;
    } else {
      showSubscribeButton = true;
    }
    event = {"events":'Wordly',"banner_url":"/banners/bg1.png","allocated_time":"১৮০ সে.","question_set":"৬০ টি","handleBannerClick":()=>{setShowQuizDetailsModal(false);setShowGameSelectionModal(true);}}
  }else if(activeQuizBannerId === 'spelling_bee') {
    if(playerData?.isSubscribeSpellingBee) {
      showKhelunButton = true;
    } else {
      showSubscribeButton = true;
    }
    event = {"events":'Spelling Bee',"banner_url":"/banners/bg2.png","allocated_time":"১৮০ সে.","question_set":"৭ টি বর্ণ","handleBannerClick":()=>{navigate(`/quiz/?eventId=${134}`, { replace: true });}}
  }
  else if(activeQuizBannerId === 'memory_match') {
    if(playerData?.isSubscribeMemoryMatch) {
      showKhelunButton = true;
    } else {
      showSubscribeButton = true;
    }
    event = {"events":'Memory Match',"banner_url":"/banners/bg3.png","allocated_time":"আনলিমিটেড","question_set":"ইমেজ সেট মিলানো","handleBannerClick":()=>{setShowQuizDetailsModal(false);memoryMatchHardPlay();}}
  }


  function handleSubscribeButtonClick() {
    setIsLoading(true);
    fetchSubscriptionUrl(token, serviceType).then(res => {
      // window.location.replace(`${res?.redirectURL}`);
      setIsLoading(false);
      setShowQuizDetailsModal(false);
      setShowOtpModal(true);
    });
  }
  return (
    <>{activeQuizBannerId &&
      <Modal show={showQuizDetailsModal} centered dialogClassName="modal-dialog" backdrop="static" contentClassName="modalContentQuizDetailsModal" onHide={hideModalOperation}>
        {/* <Modal.Header closeButton >
        </Modal.Header> */}
        <Modal.Body style={{ maxHeight: "70vh", overflow: "scroll", display: 'block', overflowX: 'hidden', padding: '12px 12px 24px',borderRadius: '32px',backgroundColor: '#f5f5f5' }}>
        <img src={xImg} alt="logo" className={styles.xImg} onClick={hideModalOperation} />
            <div className={styles.quizCard}>
              <img
                src={event?.banner_url}
                className={styles.bannerImage}
              />
              <div className={styles.quizInfo}>
                <h3 className={styles.quizTitle}>{event?.events}</h3>
                {/* <div className={styles.quizMeta}> */}
                  <div className={styles.metaItem}>
                    <LuClock3 className={styles.icon} />
                    <span> খেলার সময়: {event.allocated_time}</span>
                  </div>
                  <div className={styles.metaItem}>
                    <GrCircleQuestion className={styles.icon} />
                    <span>প্রশ্ন: {event?.question_set}</span>
                  </div>
                  
                 {showSubscribeButton && <> <div className={styles.metaItem}>
                    <FaMoneyBill className={styles.icon} />
                    <span>৩০ টাকা ট্যাক্স সহ</span>
                  </div>
                  <div className={styles.metaItem}>
                    <FaCalendarDay className={styles.icon} />
                    <span>৭ দিনের জন্য </span>
                  </div>
                  <div className={styles.metaItem}>
                    <span>**অটো রিনিউয়াল প্রযোজ্য</span>
                  </div>
                  </>}
              </div>
                  {showKhelunButton && <button
                    className={styles.playButton}
                    onClick={event?.handleBannerClick}
                  >
                    খেলুন →
                  </button>}
                  {showSubscribeButton && <button
                    className={styles.playButton}
                    onClick={handleSubscribeButtonClick}
                  >
                    {isLoading ? <Spinner animation="border" variant="light" size="sm" /> : "সাবস্ক্রাইব করে খেলুন"}
                  </button>}

                  
              {/* <QuizRewards event={event} /> */}
              {/* <QuizWinnerList eventId={event?.id} /> */}
            </div>
          
        </Modal.Body>
      </Modal>}
    </>
  )
}

export default QuizDetailsModal